<template>
  <div class="notUpgradedList" v-loading="loading">
    <div class="title-top bg-f mb-5 topDiv">
      <span>意向客户</span>
    </div>
    <div class="bg-f p-30">
      <!-- 搜索 -->
      <div>
        <el-form :inline="true" :model="form" label-width="auto">
          <el-form-item label="客户名称:">
            <el-input v-model="form.storeName" placeholder="客户名称"></el-input>
          </el-form-item>
          <el-form-item label="业务员:">
            <el-input v-model="form.managerName" placeholder="业务员名称"></el-input>
          </el-form-item>
          <el-form-item label="所属区域:">
            <districtSelect v-model="form.districtId" class="mr-10 mb-10"/>
          </el-form-item>
          <el-form-item label="创建时间:">
            <ys-daterange-picker v-model="createTimeArr" type="date"/>
          </el-form-item>
          <el-form-item label="拜访时间:">
            <ys-daterange-picker v-model="latestVisitTimeArr" type="date"/>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="search">搜索</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="batchDiv">
        <el-link class="link" type="primary" :underline="false" @click="exportInfo">导出</el-link>
      </div>
      <!-- 表格 -->
      <div>
        <el-table :data="list"  border style="width: 100%">
          <el-table-column prop="storeName" label="客户名称"></el-table-column>
					<el-table-column prop="linkname" label="联系人"></el-table-column>
          <el-table-column prop="tel" label="联系电话"></el-table-column>
          <el-table-column prop="attr" label="联系地址"></el-table-column>
          <el-table-column prop="name" label="关联业务员"></el-table-column>
          <el-table-column prop="districtName" label="所属区域"></el-table-column>
          <el-table-column prop="gmtCreate" label="创建时间">
						<template slot-scope="{row}">
              <div>
								{{row.gmtCreate | time}}
              </div>
            </template>
					</el-table-column>
          <el-table-column prop="latestVisitTime" label="最新拜访时间">
 						<template slot-scope="{row}">
              <div>
								{{row.latestVisitTime | time}}
              </div>
            </template>
					</el-table-column>
          <el-table-column prop="visitNum" label="拜访次数"></el-table-column>
          <el-table-column prop="" label="操作" align="center">
            <template slot-scope="{row}">
              <div >
                <el-link class="link" type="primary" :underline="false" @click="update(row)">客户升级</el-link>
                <el-link class="link" type="primary" :underline="false" @click="goPage(row)">编辑</el-link>
								<el-link class="link" type="danger" :underline="false" @click="comfirmDelete(row.id)">删除</el-link>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div style="text-align:right">
        <el-pagination
          @current-change="CurrentChange"
          :current-page="form.pageIndex"
          :page-size="form.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {axiosApi, basePath, baseURI} from "~/api/api.js";
import { computeNumber, postExcelFile } from "@/utils";
import { getNotUpgradedBuyerList, deleteNotUpgradedBuyerList } from "~/api/axiosInfo";
import districtSelect from "@/components/districtSelect/districtSelect.vue";

export default {
  name: 'power',
  components: {
		districtSelect
  },
  data(){
    return {
			createTimeArr:[],
			latestVisitTimeArr:[],
      loading: false,
      form: { // 搜索参数
				storeName:null,
				managerName:null,
				districtId:null,
				pageIndex:1,
				pageSize:10
      },
      list: [],
      total: 0,     
    }
  },
  mounted(){
    // 初始触发
    this.getList()
  },
	computed:{
		formInfo(){
			this.form.createStartTime=this.createTimeArr[0]?this.createTimeArr[0]:null
			this.form.createEndTime=this.createTimeArr[1]?this.createTimeArr[1]:null
			this.form.latestVisitStartTime=this.latestVisitTimeArr[0]?this.latestVisitTimeArr[0]:null
			this.form.latestVisitEndTime=this.latestVisitTimeArr[1]?this.latestVisitTimeArr[1]:null
			return this.form
		},
	},
  methods: {
		exportInfo(){
			let body =  {}
        body = Object.assign({},this.formInfo)
        body.modelName = 'empty',
        body.startRow = 0
        body.fileName = '意向客户报表.xls'
      postExcelFile(body,'/sunrise-gateway/export/sales/trader/notUpgradedBuyer')
		},
    // 搜索
    search(){
      this.form.pageIndex = 1
			this.getList()
    },
    // 获取列表
    getList(){
      this.loading = true
			
      getNotUpgradedBuyerList(this.formInfo).then(res=>{
        this.list = res.elements
        this.total = res.totalCount
        this.loading = false
      }).catch(err=>{
        this.loading = false
      })
    },

		goPage(item) {
      this.$router.push(
        `${basePath}/clientEdit/${item.id}/0/${item.buyerId}`
      );
    },
		update(row) {
      //录入用户升级注册用户
      // console.log(row)
      //传值 traderId, type(区分进入入口)
      this.$router.push(
        `${basePath}/clientUpdate?traderId=${row.buyerId}&type=1`
      );
    },

		deleteInfo(id){
			deleteNotUpgradedBuyerList({id:id}).then(res=>{
				this.$message({
          type: 'success',
          message: '操作成功!'
        });
				this.search()
			}).catch(err=>{

			})
		},

    // 确认删除
    comfirmDelete(id){
      // type 0-禁用 1-启用
      this.$confirm(`此操作将删除该客户, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
       	this.deleteInfo(id)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });          
      });
    },
    // 分页
    CurrentChange(val){
      this.form.pageIndex = val
      this.getList()
    },
  }
}
</script>

<style lang="less">
 .notUpgradedList{
  .topDiv{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 20px;
    box-sizing: border-box;
  }
  .el-tabs__header{
    padding-left: 0;
  }
  .link{
    display: block;
    margin: 10px;
  }
  .selectDiv{
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    .inputDiv{
      box-sizing: border-box;
      width: 150px;
      text-align: right;
      padding: 0 10px 11px 0;
      height: 32px;
      line-height: 32px;
      .el-input{
        width: 110px;
      }
    }
  }
  .batchDiv{
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
 }
</style>s